/**
 * Library for all fontawesome icons used
 * Only icons explicitly imported will be used in application
 *
 * To import an entire library:
 * import brands from '@fortawesome/fontawesome-free-brands'
 * fontawesome.library.add(brands);
 */

import { library } from '@fortawesome/fontawesome-svg-core';

import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faExclamationSquare } from '@fortawesome/pro-solid-svg-icons/faExclamationSquare';
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faInfoSquare } from '@fortawesome/pro-solid-svg-icons/faInfoSquare';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faWifi1 } from '@fortawesome/pro-solid-svg-icons/faWifi1';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faArchive } from '@fortawesome/pro-solid-svg-icons/faArchive';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faUndo } from '@fortawesome/pro-solid-svg-icons/faUndo';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEnvelopeOpenText } from '@fortawesome/pro-solid-svg-icons/faEnvelopeOpenText';
import { faAlarmClock } from '@fortawesome/pro-solid-svg-icons/faAlarmClock';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faCommentAltLines } from '@fortawesome/pro-solid-svg-icons/faCommentAltLines';
import { faUserEdit } from '@fortawesome/pro-solid-svg-icons/faUserEdit';
import { faUserChart } from '@fortawesome/pro-solid-svg-icons/faUserChart';
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faArrowAltDown } from '@fortawesome/pro-solid-svg-icons/faArrowAltDown';
import { faFileCheck } from '@fortawesome/pro-solid-svg-icons/faFileCheck';
import { faLockAlt } from '@fortawesome/pro-solid-svg-icons/faLockAlt';
import { faMailBulk } from '@fortawesome/pro-solid-svg-icons/faMailBulk';
import { faRedoAlt } from '@fortawesome/pro-solid-svg-icons/faRedoAlt';
import { faReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faPencilAlt } from '@fortawesome/pro-solid-svg-icons/faPencilAlt';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCommentAltPlus } from '@fortawesome/pro-solid-svg-icons/faCommentAltPlus';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faStickyNote } from '@fortawesome/pro-solid-svg-icons/faStickyNote';
import { faLandmark } from '@fortawesome/pro-solid-svg-icons/faLandmark';
import { faLaptop } from '@fortawesome/pro-solid-svg-icons/faLaptop';
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons/faMobileAlt';
import { faArrowAltUp } from '@fortawesome/pro-solid-svg-icons/faArrowAltUp';
import { faLongArrowAltDown } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltDown';
import { faLongArrowAltUp } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltUp';
import { faArrowAltRight } from '@fortawesome/pro-solid-svg-icons/faArrowAltRight';
import { faCopy } from '@fortawesome/pro-solid-svg-icons/faCopy';
import { faCheckDouble } from '@fortawesome/pro-solid-svg-icons/faCheckDouble';

import { faShoppingCart as farShoppingCart } from '@fortawesome/pro-regular-svg-icons/faShoppingCart';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faTimesCircle as farTimesCircle } from '@fortawesome/pro-regular-svg-icons/faTimesCircle';
import { faAngleDoubleRight as farAngleDoubleRight } from '@fortawesome/pro-regular-svg-icons/faAngleDoubleRight';
import { faAngleDoubleLeft as farAngleDoubleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleDoubleLeft';
import { faSpinnerThird as farSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird';

import { faStar as falStar } from '@fortawesome/pro-light-svg-icons/faStar';
import { faUser as falUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faSignOut as falSignOut } from '@fortawesome/pro-light-svg-icons/faSignOut';
import { faSpinner as falSpinner } from '@fortawesome/pro-light-svg-icons/faSpinner';
import { faHome as falHome } from '@fortawesome/pro-light-svg-icons/faHome';
import { faMoneyBillWave as falMoneyBillWave } from '@fortawesome/pro-light-svg-icons/faMoneyBillWave';
import { faCoins as falCoins } from '@fortawesome/pro-light-svg-icons/faCoins';
import { faCommentDollar as falCommentDollar } from '@fortawesome/pro-light-svg-icons/faCommentDollar';
import { faCommentsDollar as falCommentsDollar } from '@fortawesome/pro-light-svg-icons/faCommentsDollar';
import { faUserTie as falUserTie } from '@fortawesome/pro-light-svg-icons/faUserTie';
import { faEnvelopeOpenText as falEnvelopeOpenText } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import { faCog as falCog } from '@fortawesome/pro-light-svg-icons/faCog';
import { faLifeRing as falLifeRing } from '@fortawesome/pro-light-svg-icons/faLifeRing';
import { faUserEdit as falUserEdit } from '@fortawesome/pro-light-svg-icons/faUserEdit';
import { faDollarSign as falDollarSign } from '@fortawesome/pro-light-svg-icons/faDollarSign';
import { faTimes as falTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { faArrowRight as falArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import { faArrowLeft as falArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faPencil as falPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faPrint as falPrint } from '@fortawesome/pro-light-svg-icons/faPrint';
import { faAngleDown as falAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAngleUp as falAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faMoneyCheckAlt as falMoneyCheckAlt } from '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt';
import { faMoneyCheck as falMoneyCheck } from '@fortawesome/pro-light-svg-icons/faMoneyCheck';
import { faInfoSquare as falInfoSquare } from '@fortawesome/pro-light-svg-icons/faInfoSquare';
import { faExclamationTriangle as falExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faFile as falFile } from '@fortawesome/pro-light-svg-icons/faFile';
import { faArrowUp as falArrowUp } from '@fortawesome/pro-light-svg-icons/faArrowUp';
import { faArrowDown as falArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown';
import { faSpinnerThird as falSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird';
import { faChevronRight as falChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faAt as falAt } from '@fortawesome/pro-light-svg-icons/faAt';
import { faPlusCircle as falPlusCircle } from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import { faPlus as falPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faEdit as falEdit } from '@fortawesome/pro-light-svg-icons/faEdit';
import { faCheck as falCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faBan as falBan } from '@fortawesome/pro-light-svg-icons/faBan';
import { faTrashAlt as falTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import { faBuilding as falBuilding } from '@fortawesome/pro-light-svg-icons/faBuilding';
import { faUsers as falUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faPlug as falPlug } from '@fortawesome/pro-light-svg-icons/faPlug';
import { faLongArrowDown as falLongArrowDown } from '@fortawesome/pro-light-svg-icons/faLongArrowDown';
import { faLongArrowUp as falLongArrowUp } from '@fortawesome/pro-light-svg-icons/faLongArrowUp';
import { faStickyNote as falStickyNote } from '@fortawesome/pro-light-svg-icons/faStickyNote';
import { faAsterisk as falAsterisk } from '@fortawesome/pro-light-svg-icons/faAsterisk';
import { faStore as falStore } from '@fortawesome/pro-light-svg-icons/faStore';
import { faPeopleArrows as falPeopleArrows } from '@fortawesome/pro-light-svg-icons/faPeopleArrows';
import { faBalanceScaleRight as falBalanceScaleRight } from '@fortawesome/pro-light-svg-icons/faBalanceScaleRight';
import { faCogs as falCogs } from '@fortawesome/pro-light-svg-icons/faCogs';
import { faSave as falSave } from '@fortawesome/pro-light-svg-icons/faSave';
import { faUserLock as falUserLock } from '@fortawesome/pro-light-svg-icons/faUserLock';
import { faShareSquare as falShareSquare } from '@fortawesome/pro-light-svg-icons/faShareSquare';
import { faFileExport as falFileExport } from '@fortawesome/pro-light-svg-icons/faFileExport';
import { faUndo as falUndo } from '@fortawesome/pro-light-svg-icons/faUndo';
import { faFileInvoiceDollar as falFileInvoiceDollar } from '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import { faAngleDoubleRight as falAngleDoubleRight } from '@fortawesome/pro-light-svg-icons/faAngleDoubleRight';
import { faAngleDoubleLeft as falAngleDoubleLeft } from '@fortawesome/pro-light-svg-icons/faAngleDoubleLeft';
import { faUniversity as falUniversity } from '@fortawesome/pro-light-svg-icons/faUniversity';
import { faBoxUsd as falBoxUsd } from '@fortawesome/pro-light-svg-icons/faBoxUsd';
import { faHandHoldingUsd as falHandHoldigUsd } from '@fortawesome/pro-light-svg-icons/faHandHoldingUsd';
import { faCashRegister as falCashRegister } from '@fortawesome/pro-light-svg-icons/faCashRegister';
import { faMailBulk as falMailBulk } from '@fortawesome/pro-light-svg-icons/faMailBulk';
import { faTools as falTools } from '@fortawesome/pro-light-svg-icons/faTools';
import { faCalendarCheck as falCalendarCheck } from '@fortawesome/pro-light-svg-icons/faCalendarCheck';
import { faRocket as falRocket } from '@fortawesome/pro-light-svg-icons/faRocket';
import { faLayerPlus as falLayerPlus } from '@fortawesome/pro-light-svg-icons/faLayerPlus';
import { faBriefcase as falBriefcase } from '@fortawesome/pro-light-svg-icons/faBriefcase';
import { faUserShield as falUserShield } from '@fortawesome/pro-light-svg-icons/faUserShield';
import { faDownload as falDownload } from '@fortawesome/pro-light-svg-icons/faDownload';
import { faCheckCircle as falCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faUserPlus as falUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { faExclamationCircle as falExclamationCircle } from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import { faUserFriends as falUserFriends } from '@fortawesome/pro-light-svg-icons/faUserFriends';
import { faUserChart as falUserChart } from '@fortawesome/pro-light-svg-icons/faUserChart';
import { faCloudUpload as falCloudUpload } from '@fortawesome/pro-light-svg-icons/faCloudUpload';
import { faUpload as falUpload } from '@fortawesome/pro-light-svg-icons/faUpload';
import { faExchange as falExchange } from '@fortawesome/pro-light-svg-icons/faExchange';
import { faSync as falSync } from '@fortawesome/pro-light-svg-icons/faSync';
import { faCheckDouble as falCheckDouble } from '@fortawesome/pro-light-svg-icons/faCheckDouble';
import { faUsdCircle as falUsdCircle } from '@fortawesome/pro-light-svg-icons/faUsdCircle';
import { faFilePlus as falFilePlus } from '@fortawesome/pro-light-svg-icons/faFilePlus';
import { faExternalLinkAlt as falExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLinkAlt';
import { faQuestion as falQuestion } from '@fortawesome/pro-light-svg-icons/faQuestion';
import { faFingerprint as falFingerprint } from '@fortawesome/pro-light-svg-icons/faFingerprint';
import { faEnvelopeOpenDollar as falEnvelopeOpenDollar } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenDollar';
import { faFolderUpload as falFolderUpload } from '@fortawesome/pro-light-svg-icons/faFolderUpload';
import { faTimes as fadTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes';
import { faCheckCircle as fadCheckCircle } from '@fortawesome/pro-duotone-svg-icons/faCheckCircle';
import { faStoreAlt as falStoreAlt } from '@fortawesome/pro-light-svg-icons';

export default {

  init: () =>
    library.add(
      // SOLID
      faCaretRight,
      faStar,
      faSpinner,
      faExclamationSquare,
      faEye,
      faEyeSlash,
      faQuestionCircle,
      faSearch,
      faCalendar,
      faEllipsisH,
      faExclamationCircle,
      faCheckCircle,
      faInfoSquare,
      faInfoCircle,
      faWifi1,
      faCaretDown,
      faArchive,
      faTrash,
      faUndo,
      faEnvelope,
      faEnvelopeOpenText,
      faAlarmClock,
      faExclamationTriangle,
      faCommentAltLines,
      faUserEdit,
      faUserChart,
      faArrowAltUp,
      faArrowAltDown,
      faFileCheck,
      faLockAlt,
      faRedoAlt,
      faReceipt,
      faUser,
      faPencilAlt,
      faMailBulk,
      faPlus,
      faCheck,
      faTimes,
      faTimesCircle,
      faCommentAltPlus,
      faExclamation,
      faStickyNote,
      faLandmark,
      faLaptop,
      faMobileAlt,
      faLongArrowAltDown,
      faLongArrowAltUp,
      faArrowAltRight,
      faCopy,
      faCheckDouble,
      faArrowUp,

      // REGULAR
      farShoppingCart,
      farCheckCircle,
      farTimesCircle,
      farAngleDoubleRight,
      farAngleDoubleLeft,
      farSpinnerThird,

      // LIGHT
      faBook,
      falSpinner,
      falSignOut,
      falUser,
      falStar,
      falMoneyBillWave,
      falHome,
      falCoins,
      falCommentDollar,
      falCommentsDollar,
      falUserTie,
      falEnvelopeOpenText,
      falCog,
      falLifeRing,
      falUserEdit,
      falTimes,
      falDollarSign,
      falArrowLeft,
      falArrowRight,
      falPencil,
      falPrint,
      falAngleDown,
      falAngleUp,
      falMoneyCheckAlt,
      falMoneyCheck,
      falInfoSquare,
      falExclamationTriangle,
      falFile,
      falArrowUp,
      falArrowDown,
      falSpinnerThird,
      falMoneyCheckAlt,
      falChevronRight,
      falAt,
      falPlusCircle,
      falPlus,
      falEdit,
      falCheck,
      falBan,
      falTrashAlt,
      falBuilding,
      falUsers,
      falPlug,
      falLongArrowDown,
      falLongArrowUp,
      falStickyNote,
      falAsterisk,
      falStore,
      falPeopleArrows,
      falBalanceScaleRight,
      falCogs,
      falSave,
      falUserLock,
      falShareSquare,
      falFileExport,
      falUndo,
      falFileInvoiceDollar,
      falAngleDoubleRight,
      falAngleDoubleLeft,
      falUniversity,
      falBoxUsd,
      falHandHoldigUsd,
      falCashRegister,
      falMailBulk,
      falTools,
      falCalendarCheck,
      falRocket,
      falLayerPlus,
      falBriefcase,
      falUserShield,
      falDownload,
      falCheckCircle,
      falUserPlus,
      falExclamationCircle,
      falTrashAlt,
      falUserFriends,
      falUserChart,
      falCloudUpload,
      falUpload,
      falExchange,
      falSync,
      falCheckDouble,
      falUsdCircle,
      falFilePlus,
      falExternalLink,
      falQuestion,
      falFingerprint,
      falEnvelopeOpenDollar,
      falFolderUpload,
      falStoreAlt,

      // DUOTONE
      fadCheckCircle,
      fadTimes
    ),
};
